import {
  CREATE_VEHICLE_DETAILS,
  CREATE_VEHICLE_DETAILS_FAILURE,
  CREATE_VEHICLE_DETAILS_SUCCESS,
  GET_VEHICLE_DETAILS,
  GET_VEHICLE_DETAILS_FAILURE,
  GET_VEHICLE_DETAILS_SUCCESS,
} from "../../action/Car/types/types";

const INITIAL_STATE = {
  vehicleDetails: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CREATE_VEHICLE_DETAILS:
      return { ...state, vehicleDetails: action.payload };
    case CREATE_VEHICLE_DETAILS_SUCCESS:
      return { ...state, vehicleDetails: action.payload };
    case CREATE_VEHICLE_DETAILS_FAILURE:
      return { ...state, vehicleDetails: action.payload };
    case GET_VEHICLE_DETAILS:
      return { ...state, vehicleDetails: action.payload };
    case GET_VEHICLE_DETAILS_SUCCESS:
      return { ...state, vehicleDetails: action.payload };
    case GET_VEHICLE_DETAILS_FAILURE:
      return { ...state, vehicleDetails: action.payload };
    default:
      return state;
  }
};
